import {slugIdsCollection} from './slugIdsConfig';

const pardotFormConfig =  [
  {
    country: 'hk',
    slugIds: slugIdsCollection.type1,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-07-16/qz6f',
    local: '',
  },
  {
    country: 'hk',
    slugIds: slugIdsCollection.type1,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-07-16/qz6f',
    local: 'EN_GB',
  },
  {
    country: 'br',
    slugIds: slugIdsCollection.type1,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-08-30/2dv8h',
    local: '',
  },
  {
    country: 'br',
    slugIds: slugIdsCollection.type1,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-08-30/2dv8h',
    local: 'PT_BR',
  },
  {
    country: 'mx',
    slugIds: slugIdsCollection.type1,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-01/2f2yp',
    local: '',
  },
  {
    country: 'mx',
    slugIds: slugIdsCollection.type1,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-01/2f2yp',
    local: 'ES_XC',
  },
  {
    country: 'sg',
    slugIds: slugIdsCollection.type1,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-29/2g66m',
    local: '',
  },
  {
    country: 'sg',
    slugIds: slugIdsCollection.type1,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-29/2g66m',
    local: 'EN_GB',
  },
  {
    country: 'sg',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-07/2fn8w',
    local: '',
  },
  {
    country: 'sg',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-07/2fn8w',
    local: 'EN_GB',
  },
  {
    country: 'hk',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-08-24/2dbm1',
    local: '',
  },
  {
    country: 'hk',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-08-24/2dbm1',
    local: 'EN_GB',
  },
  {
    country: 'hk',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-20/2fwnz',
    local: 'ZH_HK',
  },
  {
    country: 'mx',
    slugIds: slugIdsCollection.type3,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-15/2fvzv',
    local: '',
  },
  {
    country: 'mx',
    slugIds: slugIdsCollection.type3,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-15/2fvzv',
    local: 'ES_XC',
  },
  {
    country: 'jp',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-21/2fx8q',
    local: '',
  },
  {
    country: 'jp',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-21/2fx8q',
    local: 'JA_JP',
  },
  {
    country: 'jp',
    slugIds: ['enterprise-ucc-june-2021'],
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-27/2jkbq',
    local: '',
  },
  {
    country: 'jp',
    slugIds: ['enterprise-ucc-june-2021'],
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-27/2jkbq',
    local: 'JA_JP',
  },
  {
    country: 'c2',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-22/2fxzs',
    local: '',
  },
  {
    country: 'c2',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-22/2fxzs',
    local: 'ZH_XC',
  },
  {
    country: 'c2',
    slugIds: [
      'enterprise-solutions-how-payments-innovation-can-help-enterprise-businesses-compete-grow-and-thrive-whitepaper',
      'enterprise-solutions-navigating-new-era-payments',
      'enterprise-solutions-mercator-study',
    ],
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-02-24/2kwkt',
    local: '',
  },
  {
    country: 'c2',
    slugIds: [
      'enterprise-solutions-how-payments-innovation-can-help-enterprise-businesses-compete-grow-and-thrive-whitepaper',
      'enterprise-solutions-navigating-new-era-payments',
      'enterprise-solutions-mercator-study',
    ],
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-02-24/2kwkt',
    local: 'ZH_XC',
  },
  {
    country: 'br',
    slugIds: slugIdsCollection.type3,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-20/2fwnd',
    local: '',
  },
  {
    country: 'br',
    slugIds: slugIdsCollection.type3,
    link: 'https://pypd.paypal-mktg.com/l/925803/2021-09-20/2fwnd',
    local: 'PT_BR',
  },
  {
    country: 'in',
    slugIds: slugIdsCollection.type4,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-27/2jkjs',
    local: '',
  },
  {
    country: 'in',
    slugIds: slugIdsCollection.type4,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-27/2jkjs',
    local: 'EN_GB',
  },
  {
    country: 'kr',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-07/2jbdr',
    local: '',
  },
  {
    country: 'kr',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-07/2jbdr',
    local: 'EN_US',
  },
  {
    country: 'vn',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-07/2jbdp',
    local: '',
  },
  {
    country: 'vn',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-07/2jbdp',
    local: 'EN_US',
  },
  {
    country: 'ph',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-07/2jbdm',
    local: '',
  },
  {
    country: 'ph',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-07/2jbdm',
    local: 'EN_US',
  },
  {
    country: 'ae',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-10/2jbpf',
    local: '',
  },
  {
    country: 'ae',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-10/2jbpf',
    local: 'EN_US',
  },
  {
    country: 'co',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-06/2jbcf',
    local: '',
  },
  {
    country: 'co',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-06/2jbcf',
    local: 'ES_XC',
  },
  {
    country: 'cr',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-10/2jbn7',
    local: '',
  },
  {
    country: 'cr',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-10/2jbn7',
    local: 'ES_XC',
  },
  {
    country: 'pe',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-10/2jbn5',
    local: '',
  },
  {
    country: 'pe',
    slugIds: slugIdsCollection.type2,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-10/2jbn5',
    local: 'ES_XC',
  },
  {
    country: 'in',
    slugIds: slugIdsCollection.type5,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-03/2j7ry',
    local: '',
  },
  {
    country: 'in',
    slugIds: slugIdsCollection.type5,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-01-03/2j7ry',
    local: 'EN_GB',
  },
  {
    country: 'us',
    slugIds: slugIdsCollection.type6,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-03-02/2kytr',
    local: 'EN_US',
  },
  {
    country: 'us',
    slugIds: slugIdsCollection.type6,
    link: 'https://pypd.paypal-mktg.com/l/925803/2022-03-02/2kytr',
    local: '',
  },
];

export default pardotFormConfig;
